import React from 'react';
import { motion } from 'framer-motion';
import { Star, Trophy, RefreshCw, ArrowLeft } from 'lucide-react';
import { CAPY_DATA } from '../../data/capyData';

const ProgressTracker = ({ progressData, onBack, onRetryCategory }) => {
    // progressData: { "wordId": { attempts: 5, success: 3, lastStatus: true/false } }

    const getStats = () => {
        const totalWords = Object.keys(progressData).length;
        if (totalWords === 0) return { mastered: 0, needsPractice: 0, masteryRate: 0 };

        let mastered = 0;
        Object.values(progressData).forEach(wordStat => {
            if (wordStat.lastStatus) mastered++;
        });

        return {
            mastered,
            needsPractice: totalWords - mastered,
            masteryRate: Math.round((mastered / totalWords) * 100)
        };
    };

    const stats = getStats();
    const needsPracticeWords = Object.keys(progressData).filter(id => !progressData[id].lastStatus);

    return (
        <div className="w-full max-w-2xl mx-auto p-6 bg-white rounded-3xl shadow-xl min-h-[60vh] flex flex-col">

            <div className="flex items-center mb-8">
                <button onClick={onBack} className="mr-4 p-2 bg-slate-50 rounded-full hover:bg-slate-100 transition-colors">
                    <ArrowLeft size={24} className="text-slate-500" />
                </button>
                <h2 className="text-2xl font-bold text-slate-700 font-nunito">Mi Progreso</h2>
            </div>

            {/* Hero Stats */}
            <div className="grid grid-cols-2 gap-4 mb-8">
                <motion.div
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    className="bg-[#FEF9E7] p-6 rounded-2xl flex flex-col items-center justify-center text-center shadow-sm relative overflow-hidden"
                >
                    <Star className="text-[#F4D35E] w-12 h-12 mb-2 absolute -top-2 -right-2 opacity-20 rotate-12" />
                    <span className="text-4xl font-black text-[#F4D35E] mb-1">{stats.mastered}</span>
                    <span className="text-sm font-bold text-[#B09228] uppercase tracking-wide">Palabras Maestras</span>
                </motion.div>

                <motion.div
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ delay: 0.1 }}
                    className="bg-[#E2F0CB] p-6 rounded-2xl flex flex-col items-center justify-center text-center shadow-sm relative overflow-hidden"
                >
                    <Trophy className="text-[#98C17F] w-12 h-12 mb-2 absolute -bottom-2 -left-2 opacity-20 -rotate-12" />
                    <span className="text-4xl font-black text-[#98C17F] mb-1">{stats.masteryRate}%</span>
                    <span className="text-sm font-bold text-[#6B8E55] uppercase tracking-wide">Vamos Creciendo</span>
                </motion.div>
            </div>

            {/* Review List */}
            <div className="flex-grow">
                <h3 className="text-lg font-bold text-slate-600 mb-4 flex items-center">
                    <RefreshCw size={20} className="mr-2 text-[#FFB7C5]" />
                    Palabras para practicar más
                </h3>

                {needsPracticeWords.length === 0 ? (
                    <div className="text-center py-10 opacity-50">
                        <p className="text-4xl mb-4">🎉</p>
                        <p className="font-nunito font-semibold">¡Todo está perfecto! Sigue aprendiendo.</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {needsPracticeWords.map(wordId => {
                            const wordData = CAPY_DATA.find(item => item.id === wordId);
                            const displayWord = wordData ? wordData.word : wordId;
                            return (
                                <div key={wordId} className="bg-slate-50 p-4 rounded-xl flex items-center justify-between border border-slate-100">
                                    <span className="font-bold text-slate-600 capitalize">{displayWord}</span>
                                    <span className="text-xs font-bold text-[#FFB7C5] bg-[#FFF0F3] px-2 py-1 rounded-full">Practicar</span>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>

        </div>
    );
};

export default ProgressTracker;
